import React from "react";
import {
  getModifiedKPIName,
  renderColorfulLegendText,
  CustomLabelList,
  formatValue,
} from "../utils/utils";
import appConstants from "../../../../../appConstants";
const [Planning, Dispatch] = appConstants.MODULES;
import {
  ResponsiveContainer,
  XAxis,
  Bar,
  BarChart,
  YAxis,
  CartesianGrid,
  Tooltip,
  LabelList,
  Legend,
} from "recharts";
import chartConfig from "../ChartConfig";

const CustomStackedBarChart = (props) => {
  let sortedModuleData
  if (props.chartConfig.title === "Total Bills") {
    sortedModuleData = [...props.data].sort((a,b) => new Date(a.planDate) - new Date(b.planDate));
  }
  return (
    <ResponsiveContainer>
      <BarChart
        onClick={props.onclick}
        data={props.chartConfig.title === "Total Bills" ? sortedModuleData : props.data}
        margin={{
          top: 25,
          right: 5,
          left: 10,
          bottom: 10,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={props.chartConfig.Xkey} type="category" tickLine={false} />
        <YAxis />
        <Tooltip formatter={formatValue} wrapperStyle={{color: chartConfig.chartColors.customLabel}}/>
        <Legend verticalAlign="top" wrapperStyle={{ lineHeight: '40px' }} formatter={renderColorfulLegendText}/>

        {/* Plotting stacked chart for planning module data based on checkbox selection */
        props.checked?.isPlanningChecked &&
          <Bar
            dataKey={`${Planning}_${props.chartConfig.dataKey1}`}
            name={getModifiedKPIName(props.chartConfig.chartlable1, Planning)}
            fill={chartConfig.chartColors.planning.color}
            stackId="a"
          />
        }
        {props.checked?.isPlanningChecked &&
          <Bar
            dataKey={`${Planning}_${props.chartConfig.dataKey2}`}
            name={getModifiedKPIName(props.chartConfig.chartlable2, Planning)}
            fill={chartConfig.chartColors.planning.stackedColor}
            stackId="a"
          >
            {props.chartConfig.title !== "Total Bills" &&
              <LabelList dataKey={props.chartConfig.Xkey} content={CustomLabelList} chartConfig={props.chartConfig}/>
            }
          </Bar>
        }

        {/* Plotting stacked chart for dispatch module data based on checkbox selection*/
        props.checked?.isDispatchChecked &&
          <Bar
            dataKey={`${Dispatch}_${props.chartConfig.dataKey1}`}
            name={getModifiedKPIName(props.chartConfig.chartlable1, Dispatch)}
            fill={chartConfig.chartColors.dispatch.color}
            stackId="b"
          />
        }
        {props.checked?.isDispatchChecked &&
          <Bar
            dataKey={`${Dispatch}_${props.chartConfig.dataKey2}`}
            name={getModifiedKPIName(props.chartConfig.chartlable2, Dispatch)}
            fill={chartConfig.chartColors.dispatch.stackedColor}
            stackId="b"
          >
            {props.chartConfig.title !== "Total Bills" &&
              <LabelList dataKey={props.chartConfig.Xkey} content={CustomLabelList} chartConfig={props.chartConfig}/>
            }
          </Bar>
        }
      </BarChart>
    </ResponsiveContainer>
  )
}

export default CustomStackedBarChart;
